
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Busonrentinpimprichichwad() {



    const cardData =
    {
        keyword: 'Bus On Rent in Pimpri Chinchwad',
        heading: 'Platinum24 Cabs: Bus On Rent in Pimpri Chinchwad',
        headingDescription: ' Platinum24 Cabs provides dependable Bus on Rent in Pimpri Chinchwad, ideal for family functions, corporate events, school trips, and pilgrimage tours. Our fleet of AC and non-AC buses offers spacious seating, ample legroom, and large luggage capacity to ensure comfort on every journey. With professional drivers, timely pickups, and affordable rental packages, we make group travel smooth and stress-free. Whether it’s a short city trip, a weekend getaway, or a long-distance outstation journey, Platinum24 Cabs guarantees safety, punctuality, and a comfortable travel experience for groups of all sizes in Pimpri Chinchwad.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort palace. Once the seat of the Maratha Empire, its massive gates, fountains, and ruins narrate tales of grandeur. Though destroyed by fire in 1828, it still draws thousands of visitors. The evening light-and-sound show recreates the legacy of Bajirao and Mastani. Tourists love exploring its historic courtyards and gardens. Shaniwar Wada is Pune’s proud heritage symbol."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, built in 1892, is a majestic monument associated with India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and other leaders were imprisoned here during the Quit India Movement. Today, it houses a museum showcasing Gandhi’s belongings and photographs. The Italian arches and sprawling lawns add architectural beauty. It is also a memorial to Kasturba Gandhi. Aga Khan Palace is Pune’s historical and inspirational landmark."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, located 25 km from Pune, is famous for the 1670 battle where Tanaji Malusare fought bravely for Chhatrapati Shivaji Maharaj. The fort offers trekking trails, temples, and panoramic views of the Sahyadris. In monsoon, mist and waterfalls make the climb enchanting. Visitors also enjoy local delicacies like pithla-bhakri at the fort. It is a blend of adventure and history. Sinhagad is Pune’s must-visit trekking and heritage spot."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most famous shrine dedicated to Lord Ganesha. The magnificent idol is adorned with gold and jewels. During Ganesh Chaturthi, the temple becomes the center of grand festivities with thousands of devotees. The temple is also known for its charitable activities. It is a spiritual and cultural icon of the city. Dagdusheth Ganpati is Pune’s divine and cultural heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is a rock-cut shrine dedicated to Lord Shiva. The temple features massive stone pillars, a sanctum, and a Nandi mandapa. Despite being in the city center, it offers peace and spirituality. Its architecture reflects ancient Indian craftsmanship. Evening chants create a mystical aura. Pataleshwar is Pune’s hidden spiritual gem."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, sculptures, musical instruments, and everyday antiques. The recreated Mastani Mahal is a highlight. It is an educational and fascinating spot for history enthusiasts. The museum preserves Indian traditions across centuries. It is Pune’s cultural treasure house."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest heritage sites, offering panoramic views of the city. At its summit stands the Parvati Temple dedicated to Lord Shiva and Goddess Parvati. Built during the Peshwa era, it also houses museums and smaller shrines. Climbing 103 steps to the top is both devotional and adventurous. Sunrise and sunset views here are mesmerizing. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global center for wellness and spirituality. Spread across lush gardens, it attracts seekers worldwide. It offers meditation, yoga sessions, and personal growth workshops. The ashram’s Zen gardens and serene meditation halls provide tranquility. It is ideal for rejuvenation and mindfulness. Osho Ashram is Pune’s international hub of peace and harmony."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Flowing streams, stone bridges, and manicured lawns make it a peaceful retreat. Families enjoy strolls, photography, and picnics here. The garden represents Indo-Japanese cultural friendship. Seasonal flowers enhance its beauty year-round. Pu La Deshpande Garden is Pune’s green oasis of calm."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a favorite weekend destination near Pune. It supplies water to the city while offering picturesque landscapes. During monsoon, the overflowing dam becomes a spectacular sight. Street food stalls selling corn and tea make it lively. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural getaway."
  }
],



       "services": [
    {
      "name": "Bus Rental Pimpri Chinchwad",
      "description": "Reliable and spacious bus rental service in Pimpri Chinchwad, perfect for large groups, school trips, corporate outings, and special events. Our buses are well-maintained, comfortable, and equipped with modern amenities to ensure a smooth and enjoyable journey. We offer competitive pricing with flexible rental durations to meet your specific travel needs."
    },
    {
      "name": "Pimpri Chinchwad Bus On Rent",
      "description": "Rent a bus in Pimpri Chinchwad for any occasion, from local sightseeing to long-distance travel. Our fleet includes a variety of bus types, including standard and mini buses, all driven by experienced, licensed drivers who prioritize safety and punctuality. Booking is simple with instant confirmation and customizable travel plans."
    },
    {
      "name": "Rent Bus in Pimpri Chinchwad",
      "description": "Book your bus rental in Pimpri Chinchwad easily with our user-friendly platform. Choose from affordable buses that accommodate different group sizes and travel purposes. Our buses come fully insured and sanitized, offering comfort, reliability, and professional service for all your group travel requirements."
    },
    {
      "name": "Pimpri Chinchwad Bus Hire",
      "description": "Efficient bus hire services in Pimpri Chinchwad for corporate events, weddings, school trips, and tourist excursions. We provide buses with modern seating arrangements, air conditioning, and safety features. Our customer support ensures smooth coordination from booking to trip completion."
    },
    {
      "name": "Affordable Bus Rental Pimpri Chinchwad",
      "description": "Get the best value with affordable bus rental options in Pimpri Chinchwad without compromising on comfort or quality. Transparent pricing with no hidden charges, flexible rental packages, and customized offers designed to fit your budget. Our buses are perfect for group travel, offering spacious seating and reliable service."
    },
    {
      "name": "Bus Booking Pimpri Chinchwad",
      "description": "Quick and hassle-free bus booking service in Pimpri Chinchwad with instant confirmation and flexible pick-up/drop-off options. Our booking system allows you to select the bus size and type, ensuring your group travels comfortably and efficiently. 24/7 customer assistance is available to help you throughout your trip."
    },
    {
      "name": "Pimpri Chinchwad Bus Service",
      "description": "Professional bus service provider in Pimpri Chinchwad offering a diverse range of buses for all travel occasions. Our buses are regularly serviced and equipped with GPS tracking to ensure safety and timely arrival. Enjoy seamless journeys with well-trained drivers who prioritize passenger comfort and road safety."
    },
    {
      "name": "Pimpri Chinchwad Mini Bus Rental",
      "description": "Mini bus rental service in Pimpri Chinchwad ideal for small to medium groups seeking convenience and comfort. Our mini buses are perfect for city tours, shuttle services, and short trips, featuring comfortable seating and air conditioning. Flexible rental options and competitive pricing make it easy to plan your travel."
    },
    {
      "name": "Bus Hire for Events Pimpri Chinchwad",
      "description": "Reliable bus hire for weddings, corporate gatherings, festivals, and other special events in Pimpri Chinchwad. We provide buses equipped to handle group transportation with professionalism and punctuality. Our event bus packages include driver services, customizable routes, and support for smooth event logistics."
    },
    {
      "name": "Pimpri Chinchwad Group Bus Rental",
      "description": "Group bus rental services in Pimpri Chinchwad designed to accommodate large groups traveling together. Whether for educational trips, corporate retreats, or family reunions, our buses ensure spacious seating, safety, and comfort. Flexible pickup locations and customizable itineraries available to suit your group’s needs."
    },
    {
      "name": "Pimpri Chinchwad Bus for Corporate Events",
      "description": "Professional bus rental services tailored for corporate events in Pimpri Chinchwad. We offer luxury and standard buses equipped with amenities such as Wi-Fi, charging ports, and comfortable seating. Perfect for transporting employees, clients, or guests efficiently and safely, with on-time pickups and dedicated customer support."
    },
    {
      "name": "Pimpri Chinchwad Bus for School Trips",
      "description": "Safe and reliable bus rental for school trips in Pimpri Chinchwad, ensuring student safety with trained drivers and well-maintained vehicles. Our buses feature comfortable seating and safety measures compliant with school transport regulations. Flexible schedules and competitive rates available to support educational excursions."
    },
    {
      "name": "Pimpri Chinchwad Bus for Tours",
      "description": "Explore Pimpri Chinchwad and nearby tourist destinations with our dedicated bus rental services for tours. Our buses offer spacious interiors, air conditioning, and expert drivers knowledgeable about popular routes and attractions. Customizable itineraries and competitive pricing ensure a memorable travel experience."
    },
    {
      "name": "Pimpri Chinchwad Bus with Driver",
      "description": "Hire buses in Pimpri Chinchwad with professional drivers committed to safe, timely, and courteous service. Our drivers are well-versed with local traffic conditions and routes to ensure a smooth travel experience. Enjoy stress-free journeys whether for corporate, personal, or event transportation needs."
    },
    {
      "name": "Pimpri Chinchwad Bus Rental Packages",
      "description": "Flexible and affordable bus rental packages in Pimpri Chinchwad designed to meet diverse group travel requirements. Packages include options for hourly rentals, full-day hires, multi-day trips, and event-specific arrangements. Transparent pricing, all-inclusive deals, and excellent customer support to make your bus rental experience hassle-free."
    }
  ],
  "tableData": [
    ["Bus Rental Pimpri Chinchwad", "Pimpri Chinchwad Bus On Rent"],
    ["Rent Bus in Pimpri Chinchwad", "Pimpri Chinchwad Bus Hire"],
    ["Affordable Bus Rental Pimpri Chinchwad", "Bus Booking Pimpri Chinchwad"],
    ["Pimpri Chinchwad Bus Service", "Pimpri Chinchwad Mini Bus Rental"],
    ["Bus Hire for Events Pimpri Chinchwad", "Pimpri Chinchwad Group Bus Rental"],
    ["Pimpri Chinchwad Bus for Corporate Events", "Pimpri Chinchwad Bus for School Trips"],
    ["Pimpri Chinchwad Bus for Tours", "Pimpri Chinchwad Bus with Driver"],
    ["Pimpri Chinchwad Bus Rental Packages", "—"]
  ],


         "whychoose": [
    {
      "WhyChooseheading": "Bus on Rent in Pimpri Chinchwad for Group Travel",
      "WhyChoosedescription": "Platinum24 Cabs offers reliable and spacious buses on rent in Pimpri Chinchwad for all types of group travel needs."
    },
    {
      "WhyChooseheading": "Ideal for School Trips, Corporate Events, and Family Functions",
      "WhyChoosedescription": "Our bus rental services are perfect for large gatherings, ensuring comfort and safety for every passenger."
    },
    {
      "WhyChooseheading": "Multiple Seating Options from 20 to 50+ Seaters",
      "WhyChoosedescription": "Choose from a wide range of buses based on your group size and travel requirements."
    },
    {
      "WhyChooseheading": "Well-Maintained, Fully Air-Conditioned Buses",
      "WhyChoosedescription": "Travel in comfort with our clean, AC buses equipped with cushioned seating and ample legroom."
    },
    {
      "WhyChooseheading": "Experienced Drivers for Long and Short Distance Travel",
      "WhyChoosedescription": "Our professional drivers are trained for both city and outstation routes to ensure a smooth journey."
    },
    {
      "WhyChooseheading": "Affordable Rates with Transparent Billing",
      "WhyChoosedescription": "Enjoy competitive rental prices with no hidden fees—fuel, tolls, and driver charges included."
    },
    {
      "WhyChooseheading": "Available for Local, Outstation, and Multi-Day Trips",
      "WhyChoosedescription": "Whether it’s a local day trip or a multi-day tour, our buses are ready to accommodate your plan."
    },
    {
      "WhyChooseheading": "Easy Booking and 24/7 Customer Support",
      "WhyChoosedescription": "Book your bus quickly and get round-the-clock assistance from our dedicated support team."
    }
  ]





















    }


const faqData = [
    {
        question: 'Does Platinum24 Cabs offer bus rentals in Pimpri Chinchwad?',
        answer: 'Yes, Platinum24 Cabs provides bus rental services in Pimpri Chinchwad for group travel, events, and tours.',
    },
    {
        question: 'How can I book a bus on rent in Pimpri Chinchwad with Platinum24 Cabs?',
        answer: 'You can book a bus easily through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of buses are available for rent in Pimpri Chinchwad?',
        answer: 'We offer a variety of buses including mini buses, coach buses, and deluxe buses to suit your group size and comfort preferences.',
    },
    {
        question: 'What is the seating capacity of the buses available for rent?',
        answer: 'Our buses range from 20 to 50+ seats, accommodating small to large groups efficiently.',
    },
    {
        question: 'Are the buses well-maintained and comfortable?',
        answer: 'Yes, all our buses are regularly serviced, clean, and equipped with comfortable seating and amenities.',
    },
    {
        question: 'Can I hire a bus for local Pimpri Chinchwad travel as well as outstation trips?',
        answer: 'Absolutely! We provide bus rentals for both local travel within Pimpri Chinchwad and long-distance journeys.',
    },
    {
        question: 'What are the rental packages available for buses in Pimpri Chinchwad?',
        answer: 'We offer flexible hourly, daily, and multi-day rental packages tailored to your travel requirements.',
    },
    {
        question: 'Do bus rentals come with drivers?',
        answer: 'Yes, all bus rentals include experienced and professional drivers for your safety and convenience.',
    },
    {
        question: 'Are safety and hygiene protocols followed for bus rentals?',
        answer: 'Yes, our buses are regularly sanitized, and drivers adhere to strict safety guidelines to ensure passenger well-being.',
    },
    {
        question: 'Is corporate bus rental service available in Pimpri Chinchwad?',
        answer: 'Yes, we provide customized corporate bus rental solutions including priority support and flexible billing options.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Suresh Patil',
        feedback: 'The bus rental service by Platinum24 Cabs in Pimpri Chinchwad was excellent. Spacious vehicle and professional driver.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Neha More',
        feedback: 'Booking a bus for our group trip was easy and hassle-free. The bus was clean and the driver very courteous.',
        rating: 5,
    },
];


































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];









const busOnRentPimpriChinchwadSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus On Rent in Pimpri Chinchwad",
  "image": "https://www.platinum24cab.com/assets/images/bus-rental-pimpri-chinchwad.jpg",
  "description": "Rent buses in Pimpri Chinchwad for group travel, corporate events, school trips, and tours. Affordable bus rental with driver options at Platinum24 Cabs.",
  "brand": {
    "@type": "Brand",
    "name": "Platinum24 Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "4500",
    "availability": "https://schema.org/InStock",
    "url": "https://www.platinum24cab.com/bus-on-rent-pimpri-chinchwad"
  }
};





    return (
        <div>

<Helmet>
  <title>Bus On Rent in Pimpri Chinchwad | Group & Corporate Bus Rental | Platinum24 Cabs</title>
  <meta
    name="description"
    content="Rent buses in Pimpri Chinchwad for group travel, corporate events, school trips, and tours. Affordable bus rental with driver options at Platinum24 Cabs."
  />
  <meta
    name="keywords"
    content="Bus Rental Pimpri Chinchwad, Pimpri Chinchwad Bus On Rent, Rent Bus in Pimpri Chinchwad, Pimpri Chinchwad Bus Hire, Affordable Bus Rental Pimpri Chinchwad, Bus Booking Pimpri Chinchwad, Pimpri Chinchwad Bus Service, Pimpri Chinchwad Mini Bus Rental, Bus Hire for Events Pimpri Chinchwad, Pimpri Chinchwad Group Bus Rental, Pimpri Chinchwad Bus for Corporate Events, Pimpri Chinchwad Bus for School Trips, Pimpri Chinchwad Bus for Tours, Pimpri Chinchwad Bus with Driver, Pimpri Chinchwad Bus Rental Packages"
  />
  <script type="application/ld+json">
    {JSON.stringify(busOnRentPimpriChinchwadSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/21.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Busonrentinpimprichichwad;